import { useCallback, memo, useState, useMemo } from 'react';
import { View } from 'react-native';
import {
  RecyclerListView,
  DataProvider,
  LayoutProvider,
} from 'recyclerlistview';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { LiveStream } from '@interfaces/liveStream';
import { useValueAsRef } from '@utils/hooks/useValueAsRef';
import StreamListItem from '@components/molecules/StreamListItem';
import { NavigationStackParamList } from '@interfaces/routes';
import { StreamListProps } from './types';

const StreamList = ({ streams }: StreamListProps) => {
  const navigation =
    useNavigation<NativeStackNavigationProp<NavigationStackParamList>>();

  const [viewWidth, setViewWidth] = useState(400);
  const viewWidthRef = useValueAsRef(viewWidth);

  const [layoutProvider] = useState(
    new LayoutProvider(
      (i) => {
        return 'LAYOUT';
      },
      (type, dim) => {
        dim.width = viewWidthRef.current;
        dim.height = 40;
      }
    )
  );

  const rowRenderer = useCallback(
    (type: string | number, stream: LiveStream) => {
      const handlePress = () => {
        navigation.navigate('video', { streamId: stream.id });
      };
      return (
        <StreamListItem
          handlePress={handlePress}
          stream={stream}
          key={stream.id}
        />
      );
    },
    [navigation]
  );

  const dataProvider = useMemo(() => {
    return new DataProvider((r1, r2) => {
      return r1 !== r2;
    }).cloneWithRows(streams);
  }, [streams]);

  return (
    <View
      style={{ width: '100%', flexShrink: 1, flexGrow: 1 }}
      onLayout={(event) => {
        const { width } = event.nativeEvent.layout;
        setViewWidth(width);
      }}
    >
      <RecyclerListView
        style={{ flex: 1 }}
        rowRenderer={rowRenderer}
        dataProvider={dataProvider}
        layoutProvider={layoutProvider}
        layoutSize={{ width: viewWidth, height: 40 }}
        canChangeSize={true}
      />
    </View>
  );
};

export default memo(StreamList);
